import Vue from 'vue';
import store from '../store';

/**
 *  系统优先推荐 使用v-permit可以(按钮权限 + 防重复点击指令)
 *  按钮权限v-permitBtn ===> 备用给部分按钮权限控制如内嵌的  radio, tab 等,
 */
const permitBtn = Vue.directive('permitBtn', {
  inserted(el, binding) {
    const buttonPermissions = store.getters.button_permissions;
    const hasPermit = buttonPermissions.find((item) => item === binding.value);
    if (binding.arg && binding.arg === 'disabled' && !hasPermit) {
      el.disabled = 'disabled';
      el.classList.add('is-disabled');
    } else if (binding.arg && binding.arg === 'remove' && !hasPermit) {
      el.parentNode.removeChild(el);
    }
  }
});

export { permitBtn };
